import axios from "../Axios/Default";
import { handleResponse } from "../Utils/Utils";

export const getMenuAll = (params, onSuccess, onError) => {
  const response = axios.get("v2/admin/menu", { params });
  return handleResponse(response, onSuccess, onError);
};

export const getMenuByRoleId = (role_id, onSuccess, onError) => {
  const response = axios.get(`v2/admin/menu/${role_id}`);
  return handleResponse(response, onSuccess, onError);
};

export const getRoleAll = (_params, onSuccess, onError) => {
  const response = axios.get("v2/admin/role", { params: _params });
  return handleResponse(response, onSuccess, onError);
};

export const createRole = (payload, onSuccess, onError) => {
  const response = axios.post(`v2/admin/role`, payload);
  return handleResponse(response, onSuccess, onError);
};

export const updateRole = (id, payload, onSuccess, onError) => {
  const response = axios.put(`v2/admin/role/${id}`, payload);
  return handleResponse(response, onSuccess, onError);
};

export const softDeleteRole = (role_id, payload, onSuccess, onError) => {
  const response = axios.put(`v2/admin/role/${role_id}/delete`, payload);
  return handleResponse(response, onSuccess, onError);
};

export const deleteRole = (role_id, onSuccess, onError) => {
  const response = axios.delete(`v2/admin/role/${role_id}`);
  return handleResponse(response, onSuccess, onError);
};
